import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "text-lg text-gray-900 font-semibold" };
const _hoisted_2 = { class: "w-48 flex flex-row items-center" };
const _hoisted_3 = {
    class: "px-2 flex flex-row items-center space-x-4",
    style: { "width": "300px" }
};
const _hoisted_4 = { class: "flex flex-row space-x-2 items-center" };
import { RefreshCw02Icon, XIcon } from '@gohighlevel/ghl-icons/24/outline';
import { UIButton, UISpace } from '@gohighlevel/ghl-ui';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalHeaderV2',
    props: {
        loading: {
            type: Boolean,
            require: true,
        },
    },
    emits: ['reset', 'close'],
    setup(__props, { emit: emits }) {
        const props = __props;
        function resetAction() {
            emits('reset');
        }
        function closeEditor() {
            emits('close');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UISpace), {
                justify: "space-between",
                align: "center"
            }, {
                default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('common.title')), 1),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(_unref(UIButton), {
                                id: "image-editor-reset-btn",
                                type: "default",
                                size: "medium",
                                onClick: resetAction,
                                disabled: __props.loading
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createVNode(_unref(RefreshCw02Icon), { class: "w-5 h-5 text-gray-900" }),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.reset')), 1)
                                    ])
                                ]),
                                _: 1
                            }, 8, ["disabled"])
                        ]),
                        _createElementVNode("div", {
                            class: "flex justify-end cursor-pointer",
                            style: { "width": "60px" },
                            onClick: closeEditor
                        }, [
                            _createVNode(_unref(XIcon), { class: "w-6 h-6 text-gray-900" })
                        ])
                    ])
                ]),
                _: 1
            }));
        };
    }
});
